$('document').ready(function() {

    var $pricing = $('.js-Pricing');

    if (!$pricing.length) {
        return;
    }

    var HELP_MESSAGE = 'Please input the number of people in your company to see prices';
    var ENTERPRISE_MESSAGE = 'Over 2,000? <a href="mailto:sales@jostle.me">Contact sales</a> for a quote.';

    // @TODO(Grey): These variables don’t do anything right now and
    // all have to do with updating and displaying the prices
    var $priceDisplay = $('.js-PriceDisplay');

    var $priceDisplayTier1 = $('.js-PriceDisplay-1');
    var $priceDisplayTier2 = $('.js-PriceDisplay-2');
    var $priceDisplayTier3 = $('.js-PriceDisplay-3');
    var $priceDisplayTier4 = $('.js-PriceDisplay-4');

    var pricingRect = $pricing[0].getBoundingClientRect();
    var $valueInput = $('.js-EmployeeCount');
    var valueInputRect = $valueInput[0].getBoundingClientRect();

    $valueInput.wrap('<span style="display: inline-block; position: relative;"></span>');

    var $pricingPrices = $('.js-PricingPrices');
    var $pricingPricesHelp = $('<div/>');
    var $pricingPricesHelpMessage = $('<p></p>');

    var $tooltip = $('<div/>');
    var $tooltipArrow = $('<div/>');
    var $tooltipBox = $('<div/>');
    var $tooltipBoxText = $('<strong>Change me</strong>');

    $pricingPrices.css({
        'position': 'relative'
    });

    /*
     * 1. Magic number based on the containers padding etc.
     * 2. This needs to be turned to none when the panel gets hidden
     */
    $pricingPricesHelp.css({
        'font-size': '16px',
        'position': 'absolute',
        'left': 0,
        'top': '-16px',  // 1.
        'bottom': '8px', // 1.
        'width': '100%',
        'opacity': 0,
        'background-color': '#fff',
        'text-align': 'center',
        'box-sizing': 'border-box',
        'padding': '24px',
        'transition': 'opacity 380ms ease-out',
        'pointer-events': 'none' // 2.
    });

    $pricingPricesHelpMessage.css({
        'position': 'absolute',
        'top': '50%',
        'left': '24px',
        'right': '24px',
        'transform': 'translateY(-50%)'
    });

    $pricingPricesHelpMessage.html(HELP_MESSAGE);

    $tooltip.addClass('PricingTooltip');
    $tooltipArrow.addClass('PricingTooltip-arrow');
    $tooltipBox.addClass('PricingTooltip-box');

    $pricingPrices
        .append($pricingPricesHelp
            .append($pricingPricesHelpMessage));

    $valueInput.parent()
        .append($tooltip
            .append($tooltipArrow)
            .append($tooltipBox
                .append($tooltipBoxText)));

    calculateAndDisplayPrice();

    $valueInput.on('focus', function() {
        $tooltip.addClass('is-hidden');
    });

    $valueInput.on('blur', function() {
        $tooltip.removeClass('is-hidden');
    });

    $valueInput.on('input', function(event) {
        var value = event.target.valueAsNumber;

        if (value > 0) {
            $pricingPricesHelp.css({ 'opacity': 0, 'pointer-events': 'none' });
        } else {
            $pricingPricesHelp.css({ 'opacity': 1, 'pointer-events': 'auto' });
            $pricingPricesHelpMessage.html(HELP_MESSAGE);
        }

        if (value >= 2000) {
            $pricingPricesHelp.css({ 'opacity': 1, 'pointer-events': 'auto' });
            $pricingPricesHelpMessage.html(ENTERPRISE_MESSAGE);
        }

        // @NOTE(Grey): We make sure the number can’t go over 2000 in this
        // input handler, and we make sure the number stays above 15 in the blur
        // handler. This is to avoid feeling janky on input (promoting a low number)
        // to 15 right out of the gate feels very intrusive
        event.target.value = Math.min(event.target.valueAsNumber, 2000);

        calculateAndDisplayPrice();
    });

    // @NOTE(Grey): The employee value input on the page is in a form, if we hit
    // enter while we have a value in the form it 'submits' the form and reloads
    // the page; On every browser _except_ Safari, we can fix this with a dummy
    // disabled submit button in the form; for Safari we have to handle this
    // with a keydown event that filters for Enter and does nothing
    $valueInput.on('keydown', function(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            event.preventDefault();
        }
    });

    function calculateAndDisplayPrice() {

        if(!$valueInput.length) {
            return;
        }

        // @NOTE(Grey): I just want to ensure we are always calculating against
        // at *least* 1 so that we don't run into any divide by zero errors
        var value = Math.max(Number($valueInput.val()), 1);

        function calculateCompletePrice(value) {
            if (value > 20000) { return ((value - 20000) * 0.5 ) + 17042.5; }
            if (value > 17500) { return ((value - 17500) * 0.5 ) + 16152.5; }
            if (value > 15000) { return ((value - 15000) * 0.5 ) + 14902.5; }
            if (value > 12500) { return ((value - 12500) * 0.5 ) + 13652.5; }
            if (value > 10000) { return ((value - 10000) * 0.55) + 12277.5; }
            if (value > 8000 ) { return ((value - 8000 ) * 0.55) + 11177.5; }
            if (value > 6000 ) { return ((value - 6000 ) * 0.6 ) + 9977.5;  }
            if (value > 5000 ) { return ((value - 5000 ) * 0.75) + 9227.5;  }
            if (value > 4000 ) { return ((value - 4000 ) * 0.9 ) + 8327.5;  }
            if (value > 3000 ) { return ((value - 3000 ) * 1.15) + 7177.5;  }
            if (value > 2000 ) { return ((value - 2000 ) * 1.35) + 5827.5;  }
            if (value > 1500 ) { return ((value - 1500 ) * 1.6 ) + 5027.5;  }
            if (value > 1000 ) { return ((value - 1000 ) * 2   ) + 4027.5;  }
            if (value > 750  ) { return ((value - 750  ) * 2.3 ) + 3452.5;  }
            if (value > 500  ) { return ((value - 500  ) * 2.75) + 2765;    }
            if (value > 400  ) { return ((value - 400  ) * 3.25) + 2440;    }
            if (value > 300  ) { return ((value - 300  ) * 3.9 ) + 2050;    }
            if (value > 250  ) { return ((value - 250  ) * 4.5 ) + 1825;    }
            if (value > 200  ) { return ((value - 200  ) * 5.25) + 1562.5;  }
            if (value > 150  ) { return ((value - 150  ) * 6   ) + 1262.5;  }
            if (value > 100  ) { return ((value - 100  ) * 7   ) + 912.5;   }
            if (value > 75   ) { return ((value - 75   ) * 8   ) + 712.5;   }
            if (value > 50   ) { return ((value - 50   ) * 8.5 ) + 500;     }
            if (value > 25   ) { return ((value - 25   ) * 10  ) + 250;     }
            if (value > 15   ) { return value * 10; }
            return 150;
        }

        var price = calculateCompletePrice(value) / value;

        // @NOTE(Grey): The 0.50 scalar is taking from the spreadsheet under
        // "Bronze as a percentage of complete", the third number is from the
        // spreadsheet under "Relative scale factors"
        $priceDisplayTier1.text('$' + Number(price * 0.50 * 1.00).toFixed(2));
        $priceDisplayTier2.text('$' + Number(price * 0.50 * 1.80).toFixed(2));
        $priceDisplayTier3.text('$' + Number(price * 0.50 * 2.40).toFixed(2));
        $priceDisplayTier4.text('$' + Number(price * 0.50 * 2.85).toFixed(2));
    }
});

$('document').ready(function() {
    var $addonsLists = $('.js-Pricing-addons');

    $addonsLists.each(function(index, it) {
        var $addonList = $(it);
        var addonLimit = $addonList.data('addonLimit');
        var addonQueue = [];

        $addonList.find('input:checked').each(function(_, input) {
            addonQueue.unshift($(input));
        });

        $addonList.on('change', 'label input', function(event) {
            var $target = $(event.target);
            var totalChecked = $addonList.find('input').filter(function(_, it) { return $(it).prop('checked') }).length;
            if (totalChecked > addonLimit) {
                var $oldestChecked = addonQueue.pop();
                $oldestChecked.prop('checked', false);
            }

            if ($target.prop('checked')) {
                addonQueue.unshift($target);
            } else {
                for (var i = 0; i < addonQueue.length; i += 1) {
                    var $it = addonQueue[i];
                    if ($it[0] == $target[0]) {
                        addonQueue.splice(i, 1);
                    }
                }
            }
        });

    });
});
